import { getSupabaseOrThrow } from '../supabaseClient'

function rpcNumber(value: unknown): number {
  if (typeof value === 'number' && Number.isFinite(value)) return Math.floor(value)
  if (typeof value === 'string' && value.trim()) {
    const n = Number.parseInt(value, 10)
    if (Number.isFinite(n)) return n
  }
  throw new Error('Nieoczekiwany format liczby użytkowników.')
}

/** Liczba kont w Auth (wymaga funkcji `registered_user_count` w bazie). */
export async function getRegisteredUserCount(): Promise<number> {
  const supabase = getSupabaseOrThrow()
  const { data, error } = await supabase.rpc('registered_user_count')
  if (error) throw new Error(error.message)
  return rpcNumber(data)
}

/**
 * Łączna liczba zebranych pieczątek (zweryfikowanych odwiedzin) w całym programie.
 * Wymaga funkcji `verified_stamps_count` w bazie (security definer, anon+authenticated).
 */
export async function getCollectedStampsCount(): Promise<number> {
  const supabase = getSupabaseOrThrow()
  const { data, error } = await supabase.rpc('verified_stamps_count')
  if (error) throw new Error(error.message)
  return rpcNumber(data)
}

/**
 * Liczba unikalnych miast pochodzenia (RPC `origin_city_count` w bazie).
 */
export async function getOriginCityCount(): Promise<number> {
  const supabase = getSupabaseOrThrow()
  const { data, error } = await supabase.rpc('origin_city_count')
  if (error) throw new Error(error.message)
  return rpcNumber(data)
}

export type OriginCluster = {
  origin: string
  memberCount: number
}

type OriginClusterRow = {
  origin: string
  member_count: number | string
}

/** Agregaty pochodzenia uczestników (RPC `community_origin_clusters`). */
export async function listOriginClusters(): Promise<OriginCluster[]> {
  const supabase = getSupabaseOrThrow()
  const { data, error } = await supabase.rpc('community_origin_clusters')
  if (error) throw new Error(error.message)
  return ((data ?? []) as OriginClusterRow[]).map((row) => ({
    origin: row.origin,
    memberCount: Number(row.member_count) || 0,
  }))
}
